var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D2E1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2051 7.03809C21.1551 7.03809 25.2051 11.0881 25.2051 16.0381C25.2051 20.9881 21.1551 25.0381 16.2051 25.0381C11.2551 25.0381 7.20508 20.9881 7.20508 16.0381C7.20508 11.0881 11.2551 7.03809 16.2051 7.03809ZM16.2051 5.53809C10.4301 5.53809 5.70508 10.2631 5.70508 16.0381C5.70508 21.8131 10.4301 26.5381 16.2051 26.5381C21.9801 26.5381 26.7051 21.8131 26.7051 16.0381C26.7051 10.2631 21.9801 5.53809 16.2051 5.53809Z",
    fill: "#2C64BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2051 15.2881H16.9551V10.0381H15.4551V15.2881H10.2051V16.7881H15.4551V22.0381H16.9551V16.7881H22.2051V15.2881Z",
    fill: "#2C64BE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestBooking);
export default __webpack_public_path__ + "static/media/requestBooking.e9266c284728bd2739215143787a23df.svg";
export { ForwardRef as ReactComponent };